import { alpha } from "@mui/material";
import theme from "../../../../../../Constants/theme";

// Constants/theme.js (or wherever you centralize your theme values)
export const foundationalStyles = {
  container: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    bgcolor: theme.main.applicationBackground, // e.g. "#1e2732"
    gap: 2,
    height: "auto",
  },
  // Wrap of the accordion list
  listBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: 1,
    border: `1px solid ${theme.border.light}`,
    borderRadius: "10px",
  },

  // Each accordion root
  accordion: {
    width: "100%",
    bgcolor: theme.main.panel, // slightly lighter than container
    border: `1px solid ${theme.border.light}`,
    color: theme.textColors.dark.primary,
    borderRadius: 1,
    boxShadow: "none",
    "&:not(:last-of-type)": {
      mb: 0,
    },
    // disable hover when disabled
    "&.Mui-disabled": {
      opacity: 0.5,
    },
  },

  // The summary row
  summary: {
    px: 1,
    py: 1,
    m: 0,
    "& .MuiAccordionSummary-content": {
      m: 0,
    },
    "& .Mui-expanded": {
      py: 0,
      px: 0,
      m: 0,
    },
    "& .MuiAccordionSummary-expandIconWrapper": {
      color: theme.textColors.light,
    },
    "&:hover": {
      bgcolor: alpha(theme.main.primaryBlue, 0.05),
    },
  },

  // The details region
  details: {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    borderTop: `1px solid ${theme.border.light}`,
    width: "100%",
    padding: "3px 5px",
  },

  // Wrapper for each checkbox item
  checkboxRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    width: "100%",
    gap: 1,
    py: 0,
    px: 1,
    borderRadius: 1,
  },

  // The parameter inputs on the right
  paramBox: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    border: `1px solid ${theme.border.light}`,
    borderRadius: "10px",
  },

  // TextField overrides
  textField: {
    bgcolor: theme.main.panel,
    borderRadius: 1,
    "& .MuiInputBase-root": {
      color: theme.textColors.light,
    },
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.main.border,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: theme.main.primaryBlue,
    },
    "& .MuiInputLabel-root": {
      color: theme.textColors.light,
      fontSize: theme.typography.fontSize.xs,
    },
  },
};
